import ProductContainer from './product_container';

const Product = ProductContainer;
export default Product;
